/* eslint-disable */
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { Form, Row, Col, Select, message, Card } from 'antd';
import { Button } from 'components';
import * as MensGrales from 'constants/MensajesGenerales';
import PropTypes from 'prop-types';
import { useForm } from 'antd/es/form/Form';
import {
  getFiltrosPublico,
  getEntidadesPublico,
  getBeneficiadosPublico,
  getTiposMonitoreo,
  getTiposHallazgo,
  getPublicDownloads,
  clearPublicDownloads
} from 'actions/publicDownloads.actions';
import './BuscadorDescargasPublicas.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';

function removeDuplicates(arr) {
  return arr.filter(
    (v, i, a) => a.findIndex((v2) => JSON.stringify(v) === JSON.stringify(v2)) === i
  );
}

const BuscadorDescargasPublicas = ({ onSearch, catalogos }) => {
  const dispatch = useDispatch();
  const [messageApi] = message.useMessage();
  const [searchForm] = useForm();
  const [procesosEspecificos, setProcesosEspecificos] = useState([]);
  const [tipoMonitoreos, setTipoMonitoreos] = useState([]);
  const [estados, setEstados] = useState([]);
  const [sujetosObligados, setSujetosObligados] = useState([]);
  const [beneficiados, setBeneficiados] = useState([]);
  const [beneficiadosOptions, setBeneficiadosOptions] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [tiposHallazgo, setTiposHallazgo] = useState([]);

  // Se preparan los datos de los selects sin dependencias
  const { procesosElectorales } = catalogos;

  const handleSearchByFilters = async () => {
    try {
      const params = await searchForm.validateFields();

      // Realizar la búsqueda con los parámetros
      const { success, response } = await dispatch(
        getPublicDownloads({
          idProcesoGral: params.idProcesoElectoral,
          idProcesoEspecifico: params.idProcesoEspecifico,
          idEntidad: params.idEstado,
          idSujetoObligado: params.idSujetoObligado,
          beneficiado: params.idBeneficiado,
          cargo: params.idCargo,
          idTipoMonitoreo: params.idTipoMonitoreo,
          idTipoHallazgo: params.idTipoHallazgo
        })
      );
      if (success && response?.data.code === 200) {
        onSearch(params);
      } else if (response?.causa !== undefined) {
        messageApi.error(response.causa);
      } else {
        messageApi.error(MensGrales.MAV1_2);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClearFilters = () => {
    searchForm.resetFields();
    onSearch({});
    dispatch(clearPublicDownloads({}));
  };

  const clearOnCheckAdvSearch = () => {
    searchForm.resetFields(['idSujetoObligado', 'idBeneficiado', 'idCargo']);
    setSujetosObligados([]);
    setBeneficiados([]);
    setBeneficiadosOptions([]);
    setCargos([]);
  };
  const checkAdvancedSearch = async () => {
    const procElect = searchForm.getFieldValue('idProcesoElectoral');
    const procEsp = searchForm.getFieldValue('idProcesoEspecifico');
    const idEstado = searchForm.getFieldValue('idEstado');

    clearOnCheckAdvSearch();

    if (procElect && procEsp && idEstado) {
      if (procElect && procEsp && idEstado) {
        const { success: scsBenef, response: respBenef } = await dispatch(
          getBeneficiadosPublico(
            { idProceso: procElect, idEstado, procesoEspecifico: procEsp },
            false
          )
        );
        if (scsBenef && respBenef?.data) {
          setBeneficiados(respBenef?.data);
          const sos = respBenef?.data
            .filter(
              (b) =>
                   b.idProcesoGral === procElect 
                && ((procEsp === 4)? 1 === 1 : b.idProcesoSIMAC === procEsp) // Validaciones "Intercampaña" -- Si es intercampaña no se toma encuenta el proceso específico
                && b.idEstado === idEstado
            )
            .map((b) => ({
              idSujetoObligado: b.idSujetoObligado,
              sujetoObligado: b.sujetoObligado
            }));
          setSujetosObligados(removeDuplicates(sos));
        }
      }
    }
  };

  const clearOnProcesoElectoralChange = () => {
    searchForm.resetFields([
      'idProcesoEspecifico',
      'idEstado',
      'idSujetoObligado',
      'idBeneficiado',
      'idCargo',
      'idTipoMonitoreo',
      'idTipoHallazgo'
    ]);

    setProcesosEspecificos([]);
    setEstados([]);
    setSujetosObligados([]);
    setBeneficiados([]);
    setBeneficiadosOptions([]);
    setCargos([]);
    setTipoMonitoreos([]);
    setTiposHallazgo([]);
  };

  const handleChangeProcesoElectoral = async () => {
    const procElect = searchForm.getFieldValue('idProcesoElectoral');
    clearOnProcesoElectoralChange();

    if (procElect) {
      const { success: scsCatsPublico, response: respCatsPublico } = await dispatch(
        getFiltrosPublico({ idProceso: procElect }, false)
      );
      const { success: scsTipoMonit, response: respTipoMonit } = await dispatch(
        getTiposMonitoreo({ idProceso: procElect }, false)
      );
      const { success: scsEstados, response: respEstados } = await dispatch(
        getEntidadesPublico({ idProceso: procElect }, false)
      );

      if (scsCatsPublico && respCatsPublico?.data) {
        const procesos = respCatsPublico.data.filter((cp) => cp.grupo === 'ProcesoEspecifico');
        setProcesosEspecificos(procesos || []);
      }
      if (scsTipoMonit && respTipoMonit?.data) {
        setTipoMonitoreos(respTipoMonit.data);
      }
      if (scsEstados && respEstados?.data) {
        const estadosFiltrados = respEstados.data.filter((e) => e.id > 0);
        setEstados(estadosFiltrados);
      }
    }
  };

  const clearOnSujetoObligadoChange = () => {
    searchForm.resetFields(['idBeneficiado', 'idCargo']);
    setBeneficiadosOptions([]);
    setCargos([]);
  };
  const handleChangeSujetoObligado = async () => {
    const procElect = searchForm.getFieldValue('idProcesoElectoral');
    const procEsp = searchForm.getFieldValue('idProcesoEspecifico');
    const idEstado = searchForm.getFieldValue('idEstado');
    const idSO = searchForm.getFieldValue('idSujetoObligado');

    clearOnSujetoObligadoChange();
    if (idSO) {
      // Filtrar los beneficiados conforme a los parámetros
      const benOptions = beneficiados
        .filter(
          (b) =>
               b.idProcesoGral === procElect 
            && ((procEsp === 4)? 1 === 1 : b.idProcesoSIMAC === procEsp) // Validaciones "Intercampaña" -- Si es intercampaña no se toma encuenta el proceso específico
            && b.idEstado === idEstado 
            && (!idSO || (idSO && b.idSujetoObligado === idSO))
        )
        .map((b) => ({
          nombreBeneficiado: b.nombreBeneficiado
        }));
      setBeneficiadosOptions(benOptions);

      const cargosOptions = beneficiados
        .filter(
          (b) =>
               b.idProcesoGral === procElect 
            && ((procEsp === 4)? 1 === 1 : b.idProcesoSIMAC === procEsp) // Validaciones "Intercampaña" -- Si es intercampaña no se toma encuenta el proceso específico
            && b.idEstado === idEstado 
            && (!idSO || (idSO && b.idSujetoObligado === idSO))
        )
        .map((b) => ({
          cargo: b.cargo
        }));
      setCargos(cargosOptions);
    }
  };

  const clearOnTipoMonitoreoChange = () => {
    searchForm.resetFields(['idTipoHallazgo']);
    setTiposHallazgo([]);
  };
  const handleChangeTipoMonitoreo = async () => {
    const procElect = searchForm.getFieldValue('idProcesoElectoral');
    const tipoMonitoreo = searchForm.getFieldValue('idTipoMonitoreo');
    clearOnTipoMonitoreoChange();

    if (tipoMonitoreo) {
      const { success: scsHallazgos, response: respHallazgos } = await dispatch(
        getTiposHallazgo({ idProceso: procElect, idMonitoreo: tipoMonitoreo }, false)
      );

      if (scsHallazgos && respHallazgos?.data) {
        setTiposHallazgo(respHallazgos?.data || []);
      }
    }
  };

  return (
    <div className="buscador-monitoreo">
      <Form form={searchForm} layout="vertical">
        <Card>
          <Row gutter={24}>
            <Col xs={6}>
              <Form.Item
                label="Proceso Electoral:"
                name="idProcesoElectoral"
                required
                rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                <Select
                  placeholder="Selecciona"
                  allowClear
                  onClear={() => {
                    clearOnProcesoElectoralChange();
                  }}
                  options={procesosElectorales || []}
                  fieldNames={{
                    value: 'idProcesoGeneral',
                    label: 'descripcion'
                  }}
                  onChange={handleChangeProcesoElectoral}
                  filterOption={(inputValue, option) =>
                    option.descripcion?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                  }
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col xs={6}>
              <Form.Item
                label="Proceso:"
                name="idProcesoEspecifico"
                rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                <Select
                  placeholder="Selecciona"
                  allowClear
                  onClear={() => {
                    clearOnCheckAdvSearch();
                  }}
                  options={procesosEspecificos || []}
                  fieldNames={{
                    value: 'idFiltro',
                    label: 'descripcion'
                  }}
                  onChange={checkAdvancedSearch}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col xs={6}>
              <Form.Item
                label="Entidad:"
                name="idEstado"
                rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                <Select
                  placeholder="Selecciona"
                  allowClear
                  onClear={() => {
                    clearOnCheckAdvSearch();
                  }}
                  options={estados || []}
                  fieldNames={{
                    value: 'id',
                    label: 'valor'
                  }}
                  filterOption={(inputValue, option) =>
                    option.nombreEstado?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                  }
                  onChange={checkAdvancedSearch}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col xs={6}>
              <Form.Item
                label="Sujeto Obligado:"
                name="idSujetoObligado"
                rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                <Select
                  placeholder="Selecciona"
                  allowClear
                  onClear={() => {
                    clearOnSujetoObligadoChange();
                  }}
                  disabled={sujetosObligados.length === 0}
                  options={sujetosObligados || []}
                  fieldNames={{
                    value: 'idSujetoObligado',
                    label: 'sujetoObligado'
                  }}
                  onChange={handleChangeSujetoObligado}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <br />

        <Card>
          <Row gutter={24}>
            <Col xs={24}>
              <span className="buscador-monitoreo-etiqueta">BÚSQUEDA AVANZADA</span>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={6}>
              <span className="buscador-monitoreo-etiqueta">Beneficiado:</span>
              <Form.Item name="idBeneficiado">
                <Select
                  placeholder="Selecciona"
                  allowClear
                  options={beneficiadosOptions || []}
                  disabled={beneficiadosOptions.length === 0}
                  fieldNames={{
                    value: 'nombreBeneficiado',
                    label: 'nombreBeneficiado'
                  }}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col xs={6}>
              <span className="buscador-monitoreo-etiqueta">Cargo:</span>
              <Form.Item name="idCargo">
                <Select
                  placeholder="Selecciona"
                  allowClear
                  options={cargos || []}
                  disabled={cargos.length === 0}
                  fieldNames={{
                    value: 'cargo',
                    label: 'cargo'
                  }}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col xs={6}>
              <span className="buscador-monitoreo-etiqueta">Monitoreo:</span>
              <Form.Item name="idTipoMonitoreo">
                <Select
                  placeholder="Selecciona"
                  allowClear
                  onClear={() => {
                    clearOnTipoMonitoreoChange();
                  }}
                  options={tipoMonitoreos || []}
                  fieldNames={{
                    value: 'id',
                    label: 'valor'
                  }}
                  onChange={handleChangeTipoMonitoreo}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col xs={6}>
              {tiposHallazgo.length > 0 && (
                <div>
                  <span className="buscador-monitoreo-etiqueta">Hallazgo:</span>
                  <Form.Item name="idTipoHallazgo">
                    <Select
                      placeholder="Selecciona"
                      allowClear
                      options={tiposHallazgo || []}
                      disabled={tiposHallazgo.length === 0}
                      fieldNames={{
                        value: 'id',
                        label: 'valor'
                      }}
                      showSearch
                    />
                  </Form.Item>
                </div>
              )}
            </Col>
          </Row>
        </Card>

        <Row gutter={24}>
          <Col xs={8} />
          <Col xs={8}>
            <span className="buscador-monitoreo-etiqueta" />
            <div className="buscador-monitoreo-acciones">
              <Button text="Limpiar" className="btnLimpiar" onClick={handleClearFilters} />
              <span style={{ width: '2em' }} />
              <Button text="Buscar" type="primary" onClick={handleSearchByFilters} />
            </div>
          </Col>
          <Col xs={8} />
        </Row>
      </Form>
    </div>
  );
};

export default BuscadorDescargasPublicas;

BuscadorDescargasPublicas.propTypes = {
  onSearch: PropTypes.func.isRequired,
  catalogos: PropTypes.shape({
    procesosElectorales: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired
};
